import SectionSwitch from './section-switch';

export default SectionSwitch;
